import { useEffect, useState } from "react"

export function useWindowHeight() {
    const [windowHeight, setWindowHeight] = useState(0)
    useEffect(() => {
        if (!window) return
        const getWindowHeight = () => {
            setWindowHeight(window.innerHeight)
        }
        getWindowHeight()
        window.addEventListener("resize", getWindowHeight)
        return () => {
            window.removeEventListener("resize", getWindowHeight)
        }
    }, [])
    return windowHeight
}
